interface PageLoadingFallbackProps {
  sections?: number;
}

export function PageLoadingFallback({ sections = 1 }: PageLoadingFallbackProps) {
  return (
    <div className="space-y-6 p-6">
      {Array.from({ length: sections }).map((_, i) => (
        <div key={i} className="rounded-lg border border-zinc-200 bg-white shadow-sm">
          <div className="p-6">
            <div className="mb-6 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="h-6 w-16 animate-pulse rounded bg-zinc-200"></div>
                <div className="h-5 w-32 animate-pulse rounded bg-zinc-200"></div>
              </div>
              <div className="h-8 w-8 animate-pulse rounded bg-zinc-200"></div>
            </div>
            <div className="min-h-144.5 w-full">
              <div className="space-y-4">
                {Array.from({ length: 10 }).map((_, j) => (
                  <div key={j} className="h-12 animate-pulse rounded bg-zinc-100"></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
